import { Avatar } from '@air/primitive-avatar';

export const AccountButtonSkeleton = () => (
  <div className="flex size-10 items-center justify-center bg-transparent">
    <Avatar size={24} className="opacity-30" />
  </div>
);
